import { minWidthQueries } from '@operations/utils/useMediaQuery'
import React from 'react'
import styled from 'styled-components'

const BgElement = styled.div`
  width: 20px;
  height: 100%;
  position: absolute;
  top: 0;
  background: ${({ theme }) => `url(${theme.images.whitePattern})`};
  background-size: 300px;
  @media ${minWidthQueries.md} {
    width: 40px;
  }
`
const BgElementLeft = styled(BgElement)`
  left: 0;
`
const BgElementRight = styled(BgElement)`
  right: 0;
`

const LeftRightBg = () => {
  return (
    <>
      <BgElementLeft />
      <BgElementRight />
    </>
  )
}

export default LeftRightBg
